export class Device {
    constructor(id, label, owner, notOwned, connectivity, attributes, lastActivity, provisioningInProcess, deviceProfileId) {
        this.id = id;
        this.label = label;
        this.owner = owner;
        this.notOwned = notOwned;
        this.connectivity = connectivity;
        this.attributes = attributes;
        this.lastActivity = lastActivity;
        this.provisioningInProcess = provisioningInProcess;
        this.deviceProfileId = deviceProfileId;
    }
}
export class DevicePatch {
    constructor(id, label = null, deviceProfileId = null, attributes = null, configuration = null) {
        this.id = id;
        this.label = label;
        this.deviceProfileId = deviceProfileId;
        this.attributes = attributes;
        this.configuration = configuration;
    }
}
export class NewDevice {
    constructor(id, label, connectivity, deviceProfileId = null, certificate = null, algorithm = "RSA_2048") {
        this.id = id;
        this.label = label;
        this.connectivity = connectivity;
        this.deviceProfileId = deviceProfileId;
        this.certificate = certificate;
        this.algorithm = algorithm;
    }
}
export class AdditionalParams {
}
//# sourceMappingURL=DeviceManager.js.map